enum ModGroupWalletType {
  Quantity = 'quantity',
  Dollar = 'dollar',
}

export { ModGroupWalletType };
